// A YouTube link going into the API and the chapters coming back, written out like a YouTube description.
// Real output: a Harvard lecture processed by the API. Shown on /developers and in the home page's API section.
import React from 'react';
import { PUBLIC_BASE_URL, SAMPLE_CHAPTERS, SAMPLE_VIDEO_URL } from '../../myApi/apiDocsContent';

export default function ApiConsole({ chapters = SAMPLE_CHAPTERS.length }) {
  return (
    <div className="dev-console" role="img" aria-label="An API request with a YouTube link, and the chapters the API returns for that video">
      <div className="dev-console-part">
        <p className="dev-console-label">
          <span className="dev-console-method">POST</span> /v1/videos
        </p>
        <pre className="dev-console-code">
          <code>
            {`curl -X POST ${PUBLIC_BASE_URL}/videos \\\n  -H "Authorization: Bearer $BUMPUPS_API_KEY" \\\n  -d '{"url": "`}
            <span className="dev-console-url">{SAMPLE_VIDEO_URL}</span>
            {`"}'`}
          </code>
        </pre>
      </div>
      <div className="dev-console-part dev-console-part--out">
        <p className="dev-console-label">
          <span className="dev-console-status">200</span> chapters_text
        </p>
        <p className="dev-console-video">Justice: What&apos;s The Right Thing To Do? Episode 01</p>
        <ol className="dev-console-chapters">
          {SAMPLE_CHAPTERS.slice(0, chapters).map((c, i) => (
            <li key={c.timestamp} style={{ '--i': i }}>
              <span className="dev-console-time">{c.timestamp}</span> {c.title}
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
